module.exports = __webpack_public_path__ + "static/projects-741f36505ce6b27d51028e8c61b08ad8.jpg";